import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ErrorCode, Validator } from '@symphony-solo/shared/error-handling/src';
import { loadModifiersSuccessAction } from '../+state';
import { ModifierDto } from '../dtos';

export class ModifiersValidator extends Validator<ModifierDto[]> {
  public validate(): TypedAction<any> {
    if (this.data?.length > 0) {
      return loadModifiersSuccessAction({ modifiers: this.data });
    }
    throw new AppStateFailureBuilder()
      .setFailureType(FailureType.Validation)
      .addFailure(new AppStateFailureItemWithErrorCode('No Modifiers', ErrorCode.NoModifiers))
      .build();
  }
}
